/**
* In this file contains the Appointemtnt list popup UI screen and logic
**/
import { Link } from 'react-router-dom';
import { Modal,Button } from 'react-bootstrap';
import { useEffect,useState } from 'react';
import ApiService from './../../services/ApiService';
import { convertUTCtoLocal } from './../../services/UtilsService';
import Pagination from './../../shared/components/Pagination';
import MessageModal from './../../shared/modals/MessageModal';
import AppointmentCalendarCancelModal from './../../shared/modals/AppointmentCalendarCancelModal';
import { useTranslation } from 'react-i18next';

function AppointmentsModal(props) {
	
	/**
	 * Intial state declaration
	 **/
	const [data,setData]=useState([]);
	const [count,setCount]=useState(0);
	const [request,setRequest]=useState({page:0,limit:10,member:props.data.member});
	const [modal,setModal]=useState({});
	const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
	const [showCancelModal, setShowCancelModal] = useState(false);
	const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);   
	const { t } = useTranslation();

	/** 
	* To handle Appointemtnt Delete
    * @event - we  pass the value and id 
    * id - pass the particular appointment record id
	* value - pass the boolean value
	**/
	/* const handleDelete =async (event) => {
		const {value,id}=event;
		if(value){
			await setModal({...modal,delete:!value});
			const response = await ApiService.deleteAppointment(id);
			if(response.status===200){
				setModal({...modal,value:value,modal:'success'})
				setRequest({page:0,limit:10,member:props.data.member});
				toast.success(response?.data?.message);
			}else{
				toast.error(response?.data?.message);
			}
		}	
	}; */

	//Component initialize function
	useEffect(()=>{
		const fetchData = async () => {
			setIsLoading(true); 
			try {
				var response = await ApiService.getMemberAppointment(request);
				if(response.status===200){
				   setData(response.data.items);
				   setCount(response.data.count);
				} 
			}catch (error) {
				console.error('Error fetching member appointment:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();	
	},[request]);
	
	/**
	* To handle pagination event
	* @data we get the user selected page Number
	**/
	  const handlePaginate=(data)=>{  
		  setRequest(req=>({...req,page:data}));
	  };
	  
	  //To close modal
	  const handleClose=()=>setModal({});
	  
	  /**
	  * To handle Appointemtnt Update
	  **/
	  /* const handleUpdateRecords=()=>{
		  setRequest(req=>({...req,member:props.data.member}));
	  }; */
	
  return (
  <Modal 
	show={props.data.appointment} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
  {/*import MessageModal*/}
  {Object.keys(modal).length !==0 && <MessageModal data={modal} handleClose={handleClose} />}
  
  {/*import AppointmentEditModal*/}
  {/* {Object.keys(modal).length !==0 && modal.appointment_edite && <AppointmentEditModal data={modal} handleClose={handleClose} handleUpdateRecords={handleUpdateRecords}/>} */}
  
  {/*Import DeleteModal*/}
  {/* {Object.keys(modal).length !==0 && modal.delete && <DeleteModal data={modal} handleDelete={handleDelete} handleClose={handleClose} />} */}
  {showCancelModal && (
		<AppointmentCalendarCancelModal
			show={showCancelModal}
			onHide={() => setShowCancelModal(false)} // Close modal on hide
			appointmentId={selectedAppointmentId} // Pass selected appointment ID
			onCancelSuccess={() => {
				setRequest(prevRequest => ({ ...prevRequest, page: prevRequest.page }));// Reload the current page by updating the request state
				setShowCancelModal(false); // Close modal
			}}
		/>
   )}
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title" id="appointmentsModalLabel"><span className="member-name text-capitalize">{props.data.name}{t('common.possessive_suffix')} </span>{t('sidebar.appointments')}</h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  <div className="row">
		<div className="col-xxl-12 mb-5">
			<div className="table-responsive">	
			{/*Appointemtnt List Table*/}
			<table className="table table-borderless theme-table">
				<thead>
				  <tr>
					<th>{t('modal.appointmentDate')}</th>
					<th>{t('modal.appointmentDate')}</th>
					<th>{t('modal.appointmentReason')}</th>
					<th className="text-center">{t('table.notes')}</th>
					<th className="text-center">{t('modal.action')}</th>
				  </tr>
				</thead>
				<tbody>
				{data && data.length !==0 && data.map((item,i)=>(<tr key={i} className="text-capitalize">										
						<td>{convertUTCtoLocal(new Date(item.date).toUTCString())}</td>
						<td>{new Date(item.time).toLocaleTimeString()}</td>
						<td>{item.reason}</td>
						<td className="text-center">
							<span onClick={()=>setModal({show:true,message:item.notes,title:t('table.notes')})}>
							  <i className={`fa-solid fa-file-lines ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-primary'}`} />
							</span>
						  </td>
						  {/*<td className="text-center">
							<Link className="table-link text-tmYallow mx-1">
							<span onClick={()=>setModal({appointment_edite:true,appointment_id:item.id})}>
							<i className="fa-solid fa-pencil"></i></span></Link>
							<Link className="table-link text-danger mx-1">
							<i className="fa-solid fa-trash-can" onClick={()=>setModal({delete:true,id:item?.id})}></i></Link>
				</td>*/}
				<td className="text-center">
						  {new Date() < new Date(item.time) ? (
							<div>
							  {/* <Link className="table-link text-tmYallow mx-1">
								<span onClick={() => setModal({ appointment_edite: true, appointment_id: item.id })}>
								  <i className="fa-solid fa-pencil"></i>
								</span>
							  </Link> */}
							    {item.parent_physician_mapping ? (
							  <Link className="table-link text-danger mx-1">
								{/*<i className="fa-solid fa-trash-can" onClick={(e) => handleDelete(e, item.id)}></i>*/}
								<i className="fa-solid fa-trash-can" onClick={() => {setSelectedAppointmentId(item.id);setShowCancelModal(true); }}></i>
							  </Link>
							  ) : (
								<i className="fa-solid fa-trash-can text-muted" style={{ cursor: "not-allowed" }}></i>
							  )}
							</div>
						  ) : (
							<span>passed</span>
						  )}
						</td>
					</tr>))}
					{data.length ===0 && !isLoading &&<tr>
					<td colSpan="11" className="text-center text-capitalize">{t('common.noRecord')}</td>
					</tr> }
				</tbody>
			</table>
			{/*End Appointemtnt List Table*/}
		</div>	
		</div>
	</div>
	{/*Pagination*/}
	  <div className="row my-3">
		<div className="col-xxl-12 d-flex justify-content-center">
			{data.length !==0 && <Pagination page={request.page} handlePaginate={handlePaginate} total={count}  />}
			</div>
	  </div>
	  {/*End Pagination*/}
	</Modal.Body>
	{/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`} onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
	  </Modal.Footer>
	  {/*End Footer*/}
	</Modal>
  );
}

export default AppointmentsModal;
